<!--
 * @Descripttion: 报表属性设置
 * @Author: zenghua.wang
 * @Date: 2021-05-06 10:00:37
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-02-14 15:07:22
-->
<template>
  <el-dialog
    :title="dialog.title"
    :visible.sync="dialog.show"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    append-to-body
    width="50%"
    class="dialog"
  >
    <el-tabs
      v-model="activeTab"
      type="card"
      size="small"
    >
      <el-tab-pane
        label="表头设置"
        name="tab-1"
      >
        <report-column
          :form="column"
          :data="data"
          :feilds="main.apiFieldList"
        />
      </el-tab-pane>

      <el-tab-pane
        label="内容"
        name="tab-2"
      >
        <el-form
          style="margin: 20px 0"
          ref="form"
          size="small"
          label-width="120px"
          label-suffix=":"
        >
          <el-form-item label="对齐方式">
            <el-radio-group
              v-model="column.contentAlign"
              size="mini"
            >
              <el-radio-button
                v-for="(item, index) in options.alignList"
                :key="index"
                :label="item.value"
              >{{ item.label }}</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="字体颜色">
            <el-color-picker
              v-model="column.contentColor"
              :predefine="predefineColors"
            ></el-color-picker>
          </el-form-item>

          <el-form-item label="文字提示">
            <el-switch
              v-model="column.contentPopover"
              :active-color="theme.active"
              :inactive-color="theme.inactive"
            >
            </el-switch>
          </el-form-item>

        </el-form>
      </el-tab-pane>

      <el-tab-pane
        label="超链接"
        name="tab-3"
      >
        <report-link
          :form="column"
          :data="data"
          :feilds="main.apiFieldList"
        />
      </el-tab-pane>

      <el-tab-pane
        label="Mobile设置"
        name="tab-4"
      >
        <el-form
          style="margin: 20px 0"
          size="small"
          label-width="120px"
          label-suffix=":"
        >
          <el-form-item label="关键字">
            <el-switch
              v-model="column.isKeyword"
              :active-color="theme.active"
              :inactive-color="theme.inactive"
            >
            </el-switch>
          </el-form-item>

          <el-form-item label="隐藏label">
            <el-switch
              v-model="column.hideLabel"
              :active-color="theme.active"
              :inactive-color="theme.inactive"
            >
            </el-switch>
          </el-form-item>

          <el-form-item label="隐藏value">
            <el-switch
              v-model="column.hideValue"
              :active-color="theme.active"
              :inactive-color="theme.inactive"
            >
            </el-switch>
          </el-form-item>

          <el-form-item label="字体大小">
            <el-input-number v-model="column.valueFontSize" />
          </el-form-item>

          <el-form-item label="字体粗细">
            <el-select
              v-model="column.valueFontWeight"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in options.weightList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="字体颜色">
            <el-color-picker
              v-model="column.valueColor"
              :predefine="predefineColors"
            ></el-color-picker>
          </el-form-item>

        </el-form>
      </el-tab-pane>
    </el-tabs>

    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        size="small"
        @click="dialog.show = false"
      >取 消</el-button>
      <el-button
        size="small"
        type="primary"
        @click="onSubmit"
      >提 交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  theme,
  predefineColors,
  component
} from '@/dragComponents/model/default.js'

import reportColumn from './column.vue'
import reportLink from './link.vue'

export default {
  name: 'report-dialog',
  components: {
    reportColumn,
    reportLink
  },
  inject: ['main'],
  props: {
    dialog: {
      type: Object,
      default: () => {
        return {}
      }
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    column: {
      type: [Object, Array]
    }
  },
  data() {
    return {
      activeTab: 'tab-1',
      theme: theme,
      predefineColors: predefineColors,
      options: {
        alignList: component.alignType,
        weightList: component.weightType
      }
    }
  },
  methods: {
    onSubmit() {
      // 验证
      if (!this.column.prop) {
        this.$notify.error({
          title: '错误',
          message: '请选择字段！'
        })
        return
      }
      this.$emit('change', this.column)
      this.dialog.show = false
      this.onReset()
    },
    onReset() {
      this.activeTab = 'tab-1'
    }
  }
}
</script>
